import { render, staticRenderFns } from "./ZonaAdjuntos.vue?vue&type=template&id=65625aff"
import script from "./ZonaAdjuntos.vue?vue&type=script&lang=js"
export * from "./ZonaAdjuntos.vue?vue&type=script&lang=js"
import style0 from "./ZonaAdjuntos.vue?vue&type=style&index=0&id=65625aff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports